/**
 * ? Base setup of document
 * @package de Zalm Property
 * 
 * Imports dependincies and declares them for later use
 * Dependencies will be marked with * highlighting
 */


//3rd party imports
import objectFitter from 'objectFitPolyfill';
import Rellax from 'rellax';
import lineWrapDetector from '../lib/js-line-wrap-detector/src/lineWrapDetector.js';
//import scrollOut from 'scroll-out';

// Split script imports
import fieldController from './zalm.fieldController';
import menuController from './zalm.menuController';
import mapController from './zalm.mapController';

// Initatie imported classes
const   fieldHandler    = new fieldController(),
        menuHandler     = new menuController(),
        rellax          = new Rellax('.rellax');

let googleMap;
function createMap() {
    googleMap = new mapController();
}

//Open up to global scope
window.googleMap = googleMap;
window.createMap = createMap;

// initalize imported functions
objectFitPolyfill();

//scrollOut({
//    once: true
//});

/**
 * ? Ninja forms field controller
 * * zalm.fieldController.js
 * 
 * Adds data attibute to control wether the label needs
 * to be styled as a placeholder istead of label
 */
let     ninjaFields;

// Add blur and focus events to each of the ninja form fields
const addFormListeners = () => {
    [].forEach.call(ninjaFields, (field) => {
        field.addEventListener('focus', (field) => {
            fieldHandler.focusHandler(field);
        });
        field.addEventListener('blur', (field) => {
            fieldHandler.blurHandler(field);
        });
    })
}

// Listen for the ninja form ready callout
jQuery(document).on( 'nfFormReady', function() {
    ninjaFields = document.querySelectorAll('input.ninja-forms-field, textarea.ninja-forms-field');
    addFormListeners();
});

// Redirect back button clicks to /#projects
// Location hash gets removed by menuController class
const backButtons = document.getElementsByClassName('goBackButton');

[].forEach.call(backButtons, (button) => {
    button.addEventListener('click', (e) => {
        e.preventDefault();
        window.location = "/#projects";
    })
})

/**
 * ? Heading intro animation
 * * lineWrapDetector.js
 * 
 * Splits heading 1 into seperate span elements
 * then calculates width to see wich ones are on a new line
 * Adds animation delay to each new line
 */

// Declare number of lines in H1 element
const   headingOne = document.querySelector('h1'),
        headingLines = lineWrapDetector.getLines(headingOne);

// Set animation delay longer for each line
headingLines.forEach( (line, lCount) => {
    line.forEach( word => {
        word.style.animationDelay = (lCount * .4) + 's';
    });
})

/**
 * ? Safari history api fix
 * 
 * Calls loadPage function when popstate event is called
 * used to fix issues with safari history api
 */

window.addEventListener("popstate", (e) => {
    loadPage(location.pathname);
});


/**
 * ? Scroll checker
 * 
 * Checks current scroll position to see if scrolled past threshold.
 * Called on ready state change, and when scrolling
 * Data-set toggle on header element
 */

// Declare header element
const header = document.querySelector('header');

// Checck if scrolled past 60px
const checkIsBelow = () => {    
    if (window.scrollY > 60)
        header.dataset.isBelow = true;
    else
        header.dataset.isBelow = false;
}

//Call function on scroll and ready state change
window.addEventListener('scroll', e => { checkIsBelow(); }, {passive: true})
document.addEventListener('readystatechange', e => { checkIsBelow(); })